export default {
  default: () => import("/var/www/orthofresh2/layouts/default.vue").then(m => m.default || m)
}